<div class="bar-component-container">
  <p>Bar component</p>

  <div id="bar-chart"></div>
</div>
